export const DIRECTIONS_ORDER_KEY = 'directions';

export const productOrderKey = (id) => `product:${id}`;

export const externalOrderKey = (id) => `external:${id}`;

export const buildButtonOrderItems = ({
  products = [],
  externalLinks = [],
  restaurant = {},
  includeInactive = false,
} = {}) => {
  const productItems = products
    .filter((product) => includeInactive || (product.enabled && product.available !== false))
    .map((product) => ({
      key: productOrderKey(product.id),
      type: 'product',
      product,
    }));

  const externalItems = externalLinks.map((link) => ({
    key: externalOrderKey(link.id),
    type: 'external',
    link,
  }));

  const directionItems =
    includeInactive || (restaurant.showDirections !== false && restaurant.address)
      ? [{ key: DIRECTIONS_ORDER_KEY, type: 'directions' }]
      : [];

  return [...productItems, ...externalItems, ...directionItems];
};

export const normalizeButtonOrder = (buttonOrder = [], items = []) => {
  const allowed = new Set(items.map((item) => item.key));
  const seen = new Set();
  const normalized = [];

  if (Array.isArray(buttonOrder)) {
    buttonOrder.forEach((key) => {
      if (!allowed.has(key) || seen.has(key)) return;
      seen.add(key);
      normalized.push(key);
    });
  }

  items.forEach((item) => {
    if (seen.has(item.key)) return;
    seen.add(item.key);
    normalized.push(item.key);
  });

  return normalized;
};

export const orderButtonItems = (items = [], buttonOrder = []) => {
  const byKey = new Map(items.map((item) => [item.key, item]));
  return normalizeButtonOrder(buttonOrder, items)
    .map((key) => byKey.get(key))
    .filter(Boolean);
};
